export default __webpack_public_path__ + "static/media/popup--blue.1b978ad5.svg";